import React from 'react'
import Logoar from "./pics/logo.jpeg";
import Share from "../../components/share.js";
import "./jawaan.css"
import img from "./pics/sexed.png";
const sexed = () => {
  return  (
 
    <div className="shortstory-container">
        <img src={Logoar} alt="Logoar" className="logoarr" />
      <div className="blue-bg">
     
      
        
        <header class="entry-header">
		<h4 class="entry-meta"><a href="https://nooffensebut.vercel.app/MovieReviews" target='_blank' data-wpel-link="internal">Movie and Show Reviews</a></h4>
		<h1 class="entry-title">SEX EDUCATION</h1>
		<div class="entry-meta">
			<span class="byline">by <span class="author vcard"><a class="url fn n" href="https://nooffensebut.vercel.app/aboutus" target='_blank' data-wpel-link="internal">Shreya</a></span></span><span class="meta-divider"> | </span><span class="posted-on"><a href="https://nooffensebut.vercel.app/content" target='_blank' rel="bookmark" data-wpel-link="internal"><time class="entry-date published" datetime="2018-03-01T07:27:10-05:00">12.10.2023</time><time class="updated" datetime="2018-03-01T11:10:42-05:00"></time></a><span>		</span></span></div>
	</header>
       
 
  <img src={img} alt="Logoar" className="moo" />

        <div className="description1-2">
            <div className="rate">Rating: 4</div> <div className="genre">Genre:Comedy,Coming-of-age story, Drama</div>
            <p>"Sex Education" is a coming-of-age series that explores the intricate landscape of teenage life, sexuality, and relationships. Set in a picturesque British high school, the show revolves around the life of Otis Milburn. Otis's unique upbringing sets him apart - his mother, Jean, is a sex therapist. Little does he know that his home life will inadvertently turn him into an unofficial sex therapist among his classmates.</p>
<br/>
<p>Otis meets Maeve Wiley, a lone wolf, and the two decide to open a sex clinic in the school. The clinic becomes an instant hit, and an unlikely friendship is fostered between Maeve and Otis. They also have a little tension between them as Otis starts liking Maeve, and their friendship and possible relationship is tested time and time again.</p>
<br/>
<p>What makes "Sex Education" stand out is its blend of humor, drama, and genuine empathy. The characters in the show are multi-dimensional, each wrestling with their own insecurities, desires, and personal growth. The series goes beyond the superficial and dives deep into the complexities of its characters, ensuring that the viewers become emotionally invested in their journeys.</p>
<br/>
<p>The series boldly talks about often-taboo subjects head-on. It handles issues like consent, sexual orientation, and gender identity, but at the same time keeps the audience thoroughly engaged in the plot. The show also should be commended for its inclusivity. No matter what one identifies as, he/she will definitely find a character that they can relate to on the show.</p>
<br/>
<p>One of the series' key strengths is its ability to navigate serious themes while keeping a lighthearted and comedic tone. The awkwardness, confusion, and vulnerability that come with adolescence, making it highly relatable to both young adults and those who've already passed through this stage of life.</p><br/>
<p>Throughout the series, viewers witness the evolution of relationships, both romantic and platonic. These relationships are portrayed with depth and realism, allowing the audience to connect on a profound level with the characters. Maeve - Aimee, Otis-Eric and Jackson-Viv are some of my favorite friendships on the show.
</p><br/>
<p>In summary, "Sex Education" is a must-watch. It's a show that beautifully captures the essence of finding one's identity and place in the world, all while delivering engaging storytelling and memorable characters.
</p><br/>


    <hr></hr>
</div>



          <Share/>
      </div>
</div> )}

export default sexed;

 


